import RoutesMap from "route_control/RouteControl"
import PageNotFound from './PageNotFound'
import { UserLogin } from "pages/user"

// Customer portal has no role selection step: login goes straight to the dashboard
const AuthRoute = () => {
    return [
        {
            path: RoutesMap.LOGIN.path,
            element: <UserLogin />
        },
        {
            path: RoutesMap.UNKNOWN_PATH.path,
            element: <PageNotFound />
        },
    ]
}

export default AuthRoute;
